require('./bootstrap');

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip';


//import 'primevue/resources/themes/saga-blue/theme.css'       //theme
//import 'primevue/resources/themes/vela-blue/theme.css'       //theme
import '/css/base-theme.css'
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css'                           //icons
import 'primeflex/primeflex.css'                             //primeflex

InertiaProgress.init()

createInertiaApp({
  //resolve: name => require(`./Pages/${name}`),
  resolve: name => import(`./Pages/${name}`),
  setup({ el, app, props, plugin }) {
    createApp({ render: () => h(app, props) })
      .component('router-link', {})
      .use(plugin)
      .use(PrimeVue)
      .use(ToastService)
      .directive('tooltip', Tooltip)
      .mount(el)
  },
})
